/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-boolean-value */
import React, { useContext } from 'react';
import { SlideDown } from 'react-slidedown';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { NavigateToWindowWithNativeEvents } from '@components/_common/link/link';
import LinesEllipsis from 'react-lines-ellipsis/lib';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import ChevronIcon from '../../../assets/ChevronIcon';
import {
  RecallBoldText,
  RecallButton,
  RecallContentButtonWrapper,
  RecallContentWrapper,
  RecallHeaderTextWrapper,
  RecallHeaderWrapper,
  RecallTitle,
  RecallChevronIconWrapper,
  RecallContentContainer,
  RecallShowMoreText,
  RecallShowMoreWrapper,
  ShowMoreContent,
  RecallGetThisResolvedWrapper,
} from './Recall.styles';
import { capitalizeParagraph } from '../../../utils/helpers';
import { AnalyticEvents } from '../../../constants';

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

export const RecallHeader = ({ recall, cardId, cardPosition, callToAction, hasOpenRecalls, recallCount }: any) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { trackEvent } = useContext(AnalyticsContext) as any;

  const trackEventHandler = (isCardOpen: boolean, type: string) => {
    trackEvent(isCardOpen ? AnalyticEvents.ovpCardExpand : AnalyticEvents.ovpCardCollapse, {
      cardId,
      cardPosition,
      type,
    });
    datadogRum.addAction(isCardOpen ? AnalyticEvents.ovpCardExpand : AnalyticEvents.ovpCardCollapse, {
      cardId,
      cardPosition,
      type,
    });
  };

  const handleRecallCardClick = (isCardOpen: boolean) => {
    trackEventHandler(isCardOpen, 'recall');
    setIsOpen(!isOpen);
  };

  const recallName: string = recall?.name?.toString()?.toLowerCase() || `${recall?.make} Recall`;
  return (
    <>
      <RecallHeaderWrapper data-testid="recall-header-wrapper" onClick={() => handleRecallCardClick(!isOpen)}>
        <RecallHeaderTextWrapper>
          <RecallTitle hasOpenRecalls={hasOpenRecalls}>
            {isOpen ? (
              recallName
            ) : (
              <ResponsiveEllipsis
                data-testid="recalls-card-recall-title"
                text={recallName}
                maxLine={3}
                ellipsis="..."
                trimRight={true}
              />
            )}
          </RecallTitle>
        </RecallHeaderTextWrapper>
        <RecallChevronIconWrapper isOpen={isOpen}>
          <ChevronIcon />
        </RecallChevronIconWrapper>
      </RecallHeaderWrapper>
      <SlideDown>
        {isOpen && (
          <RecallContent
            recall={recall}
            cardId={cardId}
            cardPosition={cardPosition}
            callToAction={callToAction}
            recallCount={recallCount}
          />
        )}
      </SlideDown>
    </>
  );
};

export const RecallContent = ({ recall, callToAction, cardId, cardPosition, recallCount }: any) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [isShowMoreOpen, setIsShowMoreOpen] = React.useState(false);

  const { oemId, nhtsaId, risk, remedy, description } = recall;

  const handleRedirect = () => {
    trackEvent(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
      recallCount: [recallCount],
    });
    datadogRum.addAction(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
      recallCount: [recallCount],
    });
    // note = link goes to google.com, not part of carvana
    NavigateToWindowWithNativeEvents({
      url: callToAction.link,
      event: 'link',
    });
  };

  return (
    <>
      <RecallContentContainer>
        <RecallContentWrapper>
          <div>
            <RecallBoldText data-testid="recalls-card-mrn-title">Manufacturer Recall Number</RecallBoldText>
            <br />
            <p data-testid="recalls-card-mrn-value">{oemId}</p>
          </div>
          <div>
            <RecallBoldText data-testid="recalls-card-nhtsa-title">NHTSA Recall Number</RecallBoldText>
            <br />
            <p data-testid="recalls-card-nhtsa-value">{nhtsaId}</p>
          </div>
        </RecallContentWrapper>
        <RecallShowMoreWrapper>
          <RecallShowMoreText
            data-testid="recalls-card-show-more-text"
            onClick={() => setIsShowMoreOpen(!isShowMoreOpen)}
          >
            Show {isShowMoreOpen ? 'Less' : 'More'}
          </RecallShowMoreText>
        </RecallShowMoreWrapper>
        {isShowMoreOpen && (
          <ShowMoreContent>
            <RecallBoldText data-testid="recalls-card-risk-title">Safety Risk</RecallBoldText>
            <br />
            <p data-testid="recalls-card-risk-value">{capitalizeParagraph(risk)}</p>
            <RecallBoldText data-testid="recalls-card-remedy-title">Remedy</RecallBoldText>
            <p data-testid="recalls-card-remedy-value">{capitalizeParagraph(remedy)}</p>
            <RecallBoldText data-testid="recalls-card-notes-title">Manufacturer Notes</RecallBoldText>
            <p data-testid="recalls-card-notes-value">{capitalizeParagraph(description)}</p>
          </ShowMoreContent>
        )}
        <RecallGetThisResolvedWrapper>
          <div>
            <RecallBoldText data-testid="recalls-card-cta-text">Get This Resolved</RecallBoldText>
          </div>
          <RecallContentButtonWrapper>
            <RecallButton data-testid="recalls-card-cta-button" size="small" onClick={handleRedirect}>
              Find a Dealer
            </RecallButton>
          </RecallContentButtonWrapper>
        </RecallGetThisResolvedWrapper>
      </RecallContentContainer>
    </>
  );
};
